module.exports = __webpack_public_path__ + "static/media/gallery.4920d996.svg";